import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc03478c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "documentation-consulting-block-content-wrap" }
const _hoisted_2 = { class: "documentation-consulting-block" }
const _hoisted_3 = { class: "documentation-consulting-block-header-title-block margin-l" }
const _hoisted_4 = { class: "documentation-consulting-block-text" }
const _hoisted_5 = { class: "documentation-consulting-block-image-wrap" }
const _hoisted_6 = { class: "documentation-consulting-block-image" }
const _hoisted_7 = { class: "documentation-consulting-block-image" }
const _hoisted_8 = { class: "documentation-consulting-text-centre-wrap" }
const _hoisted_9 = { class: "documentation-consulting-text-centre" }
const _hoisted_10 = { class: "documentation-consulting-block-image-wrap" }
const _hoisted_11 = { class: "documentation-consulting-block-image" }
const _hoisted_12 = { class: "documentation-consulting-block-image" }
const _hoisted_13 = { class: "documentation-consulting-text-centre-wrap non" }
const _hoisted_14 = { class: "documentation-consulting-text-centre" }

import {
  ConsultingsSocumentationServices,
  ConsultingsSocumentationServices1,
  ConsultingsSocumentationServices2,
  ConsultingsSocumentationServices3,
  it_dept,
  useLocalizationStore,
} from "@/shared";
import {BlockPreviewData, WrapTitle} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'documentation-consulting-block',
  setup(__props) {

const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BlockPreviewData), {
        "body-title": _unref(translate)('consulting_documentation_services'),
        image: _unref(it_dept),
        class: "documentation-consulting-block-preview-data"
      }, {
        "header-title": _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(WrapTitle), {
              text: _unref(translate)('it_consulting_support'),
              class: "documentation-consulting-block-header-title",
              size: "regular",
              weight: "700"
            }, null, 8, ["text"])
          ])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString(_unref(translate)("consulting_documentation_services_first_text")), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(translate)("consulting_documentation_services_second_text")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                style: _normalizeStyle({backgroundImage:'url('+_unref(ConsultingsSocumentationServices)+')'}),
                class: "documentation-consulting-image"
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                style: _normalizeStyle({backgroundImage:'url('+_unref(ConsultingsSocumentationServices1)+')'}),
                class: "documentation-consulting-image"
              }, null, 4)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)("consulting_documentation_services_third_text")), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                style: _normalizeStyle({backgroundImage:'url('+_unref(ConsultingsSocumentationServices2)+')'}),
                class: "documentation-consulting-image"
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                style: _normalizeStyle({backgroundImage:'url('+_unref(ConsultingsSocumentationServices3)+')'}),
                class: "documentation-consulting-image"
              }, null, 4)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(translate)("consulting_documentation_services_fourth_text")), 1)
          ])
        ]),
        _: 1
      }, 8, ["body-title", "image"])
    ])
  ]))
}
}

})